export default __webpack_public_path__ + "static/media/img_15.4de99800.jpg";